import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { UICoupon } from "pages/vendor/Coupons/Coupons"
import CouponActionMenus from "./Components/CouponActionMenus"
import { useTranslation } from "react-i18next"

interface CouponsTableProps {
  coupons: UICoupon[]
  isAllChecked: boolean
  checkedCoupons: UICoupon[]
  toggleAllCoupons: () => void
  togglecheckedCouponHandler: (coupon: UICoupon) => void
  toogleActiveCoupon: (coupon: UICoupon) => void
  deleteCouponHandler: (coupon: UICoupon) => void
  editCouponHandler: (coupon: UICoupon) => void
  viewDetailsHandler: (coupon: UICoupon) => void
  addOfferHandler: (coupon: UICoupon) => void
  addCompaign: (coupon: UICoupon) => void
  autoAssignToDelivery: (coupon: UICoupon) => void
  location?: any
}

const CouponsTable: React.FC<CouponsTableProps> = ({
  coupons,
  isAllChecked,
  checkedCoupons,
  toggleAllCoupons,
  viewDetailsHandler,
  togglecheckedCouponHandler,
  deleteCouponHandler,
  editCouponHandler,
  toogleActiveCoupon,
  location,
  addOfferHandler,
  addCompaign,
  autoAssignToDelivery,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllCoupons}
            checked={isAllChecked}
          />
        ),
        accessor: "select",
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return (
            <input
              onClick={() => togglecheckedCouponHandler(cellProps.row.original)}
              checked={Boolean(
                checkedCoupons.find(o => o.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("coupons_serial"),
        accessor: "id",
        filterable: true,

        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return (
            <div className="d-flex flex-column align-items-start">
              <p className="mb-0">{cellProps.row.original.name}</p>
              <p className="mb-0">{cellProps.row.original.id}</p>
            </div>
          )
        },
      },
      {
        Header: t("coupons_product"),
        accessor: "count",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return <>{cellProps.row.original.count}</>
        },
      },
      {
        Header: t("coupons_price"),
        accessor: "price",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return <>QAR {cellProps.row.original.price}</>
        },
      },
      {
        Header: t("coupons_productSize"),
        accessor: "productSize",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return <>{cellProps.row.original.productSize}</>
        },
      },
      {
        Header: t("coupons_refillTimes"),
        accessor: "refillTimes",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return <>{cellProps.row.original.refillTimes}</>
        },
      },
      {
        Header: t("coupons_itemRefilOnce"),
        accessor: "itemPerRefill",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          return <>{cellProps.row.original.itemPerRefill}</>
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: UICoupon } }) => {
         const coupon = cellProps.row.original
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className={`form-check-input ${coupon.status === "Pending Approval" && "bg-warning border-warning"}`}
                id={`customSwitch${coupon.id}`}
                checked={coupon.status === "Active" || coupon.status === "Pending Approval"}
                onClick={() => toogleActiveCoupon(coupon)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${coupon.id}`}
              >
                {coupon.status}
              </label>
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: UICoupon } }) => {
          const coupon = cellProps.row.original
          return (
            <CouponActionMenus
              coupon={coupon}
              editCouponHandler={editCouponHandler}
              viewDetailsHandler={viewDetailsHandler}
              deleteCouponHandler={deleteCouponHandler}
              addOfferHandler={addOfferHandler}
              addCompaign={addCompaign}
              autoAssignToDelivery={autoAssignToDelivery}
            />
          )
        },
      },
    ],
    [coupons, t, checkedCoupons]
  )

  return (
    <TableContainer
      columns={columns}
      data={coupons}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

CouponsTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CouponsTable))
